import styled from 'styled-components';
import { TableResponsiveMixin } from '../../mixins/components/TableResponsiveMixin';
export var StyledTableResponsive = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledTableResponsive",
  componentId: "c11n-8-111-1__sc-goovyt-0"
})(["", ""], TableResponsiveMixin);